import { siteAssets } from './siteAssets';

export const socialLinks = [
  {
    name: 'GitHub',
    handle: '@DMCerYT',
    image: siteAssets.githubPositive,
    href: 'https://github.com/DMCerYT',
  },
  {
    name: 'LinkedIn',
    handle: '@Emmanuel Munoz',
    image: siteAssets.linkedInPositive,
    href: 'https://www.linkedin.com/in/emmanuel-dmcer/',
  },
  {
    name: 'Youtube',
    handle: 'DMCer',
    image: siteAssets.youtubePositive,
    href: 'https://www.youtube.com/@DMCer123',
  },
  {
    name: 'Facebook',
    handle: 'Emmanuel Munoz',
    image: siteAssets.facebookPositive,
    href: 'https://www.facebook.com/emmet.munoz.2025',
  },
  {
    name: 'Instagram',
    handle: '@official_dmcer',
    image: siteAssets.instagramPositive,
    href: 'https://www.instagram.com/official_dmcer/',
  },
  {
    name: 'Email',
    handle: 'emmet.munoz@dmcer.org',
    image: siteAssets.googlePositive,
    href: 'mailto:emmet.munoz@dmcer.org',
  },
];
